<!-- Banner -->
<fgb-banner></fgb-banner>

<router-outlet></router-outlet>
